var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForPayerFee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9023",
    "data-name": "Rectangle 9023",
    width: 12,
    height: 12,
    transform: "translate(0.222 0.222)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Positive_affirmative_notification",
    "data-name": "Positive, affirmative notification",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3239",
    "data-name": "Ellipse 3239",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(3 3)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check_mark",
    "data-name": "Check mark",
    transform: "translate(4.778 4.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6751",
    "data-name": "Mask Group 6751",
    transform: "translate(1 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273925",
    "data-name": "Group 273925",
    transform: "translate(-0.28 -0.275)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1230",
    "data-name": "Ellipse 1230",
    cx: 1.56,
    cy: 1.56,
    rx: 1.56,
    ry: 1.56,
    transform: "translate(1.946 2.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1231",
    "data-name": "Ellipse 1231",
    cx: 1.56,
    cy: 1.56,
    rx: 1.56,
    ry: 1.56,
    transform: "translate(7.936 7.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M2464.881,396.569l-6.889,7.274a.8.8,0,0,0,.58,1.348h0l6.929-7.16a.862.862,0,0,0-.62-1.462Z",
    transform: "translate(-2455.155 -394.303)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForPayerFee);
export default __webpack_public_path__ + "static/media/forPayerFee.b3abccf053cbc296d24dced792dd5809.svg";
export { ForwardRef as ReactComponent };